import { useEffect, useRef } from 'react'
import * as XLSX from 'xlsx'

import { useSelector, useDispatch } from 'react-redux'

import moment from 'moment'

import axiosInstance from '../../../../services/config/AxiosIntance'

import { setDownload, setLoading } from '../../../../store/actions/dashboardActions'

const TablesExport = () => {
    const dispatch = useDispatch()
    const { filters, tableFilters } = useSelector((state) => state.dashboard)
    const hasDownloadedRef = useRef(false)

    const csvData = [
        {
            name: 'Recruitment Type Breakdown',
            fetchData: async () => {
                const queryFilter = {
                    dates: filters?.dates?.toString(),
                }
                const queryParams = new URLSearchParams(queryFilter).toString()
                const url = `/jobs/recruitment-type-breakdown/fetchAll?${queryParams}&pageNumber=1&pageSize=10`
                const result = await axiosInstance.get(url)
                const response = result?.data?.data.map((e) => ({
                    Client: e.client,
                    'Recruitment Type': e.recruitment_stage,
                    Total: e.total,
                }))
                return response
            },
        },
        {
            name: 'Recruitment Stage Breakdown',
            fetchData: async () => {
                const queryFilter = {
                    dates: filters?.dates?.toString(),
                }
                const queryParams = new URLSearchParams(queryFilter).toString()
                const url = `/jobs/recruitment-stage-breakdown/fetchAll?${queryParams}&pageNumber=1&pageSize=10`
                const result = await axiosInstance.get(url)
                const response = result?.data?.data.map((e) => ({
                    Client: e.client,
                    'Recruitment Stages': e.recruitment_stage,
                    Total: e.total,
                }))
                return response
            },
        },
        {
            name: 'Sourcing Channel Effectiveness',
            fetchData: async () => {
                const queryFilter = {
                    ...filters,
                    dates: filters?.dates?.toString(),
                }
                const queryParams = new URLSearchParams(queryFilter).toString()
                const url = `/interview/sourcing-channel-effectiveness/fetchAll?${queryParams}&pageNumber=1&pageSize=10`
                const result = await axiosInstance.get(url)

                const response = result?.data?.data.map((e) => ({
                    Channel: e.channel,
                    'No. of candidates': e.candidates,
                    'No. of hires': e.hires,
                    Open: e.open,
                    'Conversion Rate (%)': e.conversion_rate,
                }))
                return response
            },
        },
        {
            name: 'Aging Days',
            fetchData: async () => {
                const queryFilter = {
                    dates: filters?.dates?.toString(),
                }
                const queryParams = new URLSearchParams(queryFilter).toString()
                const url = `/jobs/aging-days/fetchAll?${queryParams}&pageNumber=1&pageSize=10`
                const result = await axiosInstance.get(url)
                const capitalizeFirst = (str) =>
                    str ? str.charAt(0).toUpperCase() + str.slice(1).toLowerCase() : ''
                const response = result?.data?.data.map((e) => ({
                    Role: e.role || '',
                    Status: capitalizeFirst(e.status || ''),
                    'Aging Days': e.ageing_days ?? 0,
                }))
                return response
            },
        },
        {
            name: 'Role Status Breakdown List',
            fetchData: async () => {
                const queryFilter = {
                    dates: filters?.dates?.toString(),
                }
                const queryParams = new URLSearchParams(queryFilter).toString()
                const url = `/dashboard/role-status-breakdown/fetchAll?${queryParams}`
                const result = await axiosInstance.get(url)
                const response = result?.data?.result?.data.map((e) => ({
                    Role: e.role,
                    Client: e.client,
                    'Recruitment Type': e.recruitment_type_name,
                    'Initiation Date': moment(e.date_posted).format('MM/DD/YYYY'),
                    'Ageing Days': e.ageing_days,
                }))
                return response
            },
        },
        {
            name: 'Recruiter Ratio List',
            fetchData: async () => {
                const queryFilter = {
                    dates: filters?.dates?.toString(),
                }
                const queryParams = new URLSearchParams(queryFilter).toString()
                const url = `/jobs/recruiter-ratio/fetchAll?${queryParams}&pageNumber=1&pageSize=10`
                const result = await axiosInstance.get(url)
                const statusColumns = result?.data?.statusColumns

                const response = result?.data?.data.map((e) => ({
                    Recruiter: e.recruiter_name,
                    ...statusColumns.reduce((acc, status) => {
                        acc[status] = e[status]
                        return acc
                    }, {}),
                }))
                return response
            },
        },
        {
            name: 'Accepted Applicant List',
            fetchData: async () => {
                const queryFilter = {
                    dates: filters?.dates?.toString(),
                }
                const queryParams = new URLSearchParams(queryFilter).toString()
                const url = `/interviews/accepted-applicants/fetchAll?${queryParams}&pageNumber=1&pageSize=10`
                const result = await axiosInstance.get(url)
                const response = result?.data?.data.map((e) => ({
                    Recruiter: e.recruiter,
                    Applicant: e.applicant_name,
                    Role: e.role,
                    Client: e.client,
                    'Date Accepted': moment(e.date_accepted).format('MM/DD/YYYY'),
                }))
                return response
            },
        },
        {
            name: 'Recruiter Assigned Roles',
            fetchData: async () => {
                const queryFilter = {
                    dates: filters.dates.toString(),
                    recruiter_id: filters.recruiter_id,
                    job_id: filters.job_id,
                    company_id: filters.company_id,
                    channel_id: filters.channel_id,
                    stage_id: filters.stage_id
                }
                const queryParams = new URLSearchParams(queryFilter).toString()
                const url = `/job/recruiters-roles-current-stage/fetchAll?${queryParams}&pageNumber=1&pageSize=10`
                const result = await axiosInstance.get(url)

                const response = result?.data?.data?.data.map((e) => ({
                    Recruiter: e.recruiter_name,
                    Client: e.client,
                    Role: e.role,
                    Status: e.jobStatusTag,
                    Initiation_date: moment(e.initiation_date).format('MM/DD/YYYY'),
                    Total_aging_days: e.total_aging_days,
                    Stage_this_week: e.current_week_stage,
                    Stage_previous_week: e.prev_week_stage,
                }))
                return response
            },
        },
        {
            name: 'Active Roles Assigned Per Recruiter',
            fetchData: async () => {
                const queryFilter = {
                    dates: filters.dates.toString(),
                    recruiter_id: filters.recruiter_id,
                    job_id: filters.job_id,
                    company_id: filters.company_id,
                    channel_id: filters.channel_id,
                    stage_id: filters.stage_id,
                }
                const queryParams = new URLSearchParams(queryFilter).toString()
                const url = `/dashboard/recruiterRolesAssigned/fetchAll?${queryParams}&pageNumber=1&pageSize=10`
                const result = await axiosInstance.get(url)

                const response = result?.data?.data.map((e) => ({
                    'User Name': e.user_name,
                    'Assigned Roles': e.job_title,
                }))
                return response
            },
        },
        {
            name: 'Recruiters Candidate Count List',
            fetchData: async () => {
                const queryFilter = {
                    dates: filters.dates.toString(),
                    recruiter_id: filters.recruiter_id,
                    job_id: filters.job_id,
                    company_id: filters.company_id,
                    channel_id: filters.channel_id,
                    stage_id: filters.stage_id,
                }
                const queryParams = new URLSearchParams(queryFilter).toString()
                const url = `/interviews/recruiter-candidate-count/fetchAll?${queryParams}&pageNumber=1&pageSize=10`
                const result = await axiosInstance.get(url)
                const response = result?.data?.data.map((e) => ({
                    Recruiter: e.recruiter,
                    Client: e.client,
                    Role: e.role,
                    Stage: e.stage,
                    'Candidates count': e.candidate_count,
                }))
                return response
            },
        },
        {
            name: 'Login & Signup Usage List',
            fetchData: async () => {
                const queryFilter = {
                    dates: filters.dates.toString(),
                    recruiter_id: filters.recruiter_id,
                    job_id: filters.job_id,
                    company_id: filters.company_id,
                    channel_id: filters.channel_id,
                    stage_id: filters.stage_id
                }
                const queryParams = new URLSearchParams(queryFilter).toString()
                const url = `/dashboard/login-activities/fetchAll?${queryParams}&pageNumber=1&pageSize=10`
                const result = await axiosInstance.get(url)
                const response = result?.data?.data.map((e) => ({
                    'Applicant Id': e.applicant_id,
                    Applicant: e.applicant_name,
                    Activity: e.activities,
                    Category: e.activity_type,
                    Status: e.status,
                    'Created TimeStamp': moment(e.created_at).format('MM/DD/YYYY'),
                    'Modified TimeStamp': moment(e.updated_at).format('MM/DD/YYYY'),
                }))
                return response
            },
        },
        {
            name: 'Recruitment Stage Funnel List',
            fetchData: async () => {
                const queryFilter = {
                    dates: filters.dates.toString(),
                    recruiter_id: filters.recruiter_id,
                    job_id: filters.job_id,
                    company_id: filters.company_id,
                    channel_id: filters.channel_id,
                    stage_id: filters.stage_id,
                }
                const queryParams = new URLSearchParams(queryFilter).toString()
                const url = `/dashboard/recruitmentStageFunnelTable?${queryParams}`
                const result = await axiosInstance.get(url)
                const columns = result?.data?.result?.columns || []
                const tableData = result?.data?.result?.tableData || []
                const stageBindings = result?.data?.result?.stageBindings || {}

                const response = tableData.map((row) => {
                    const formattedRow = {
                        Month: row.month,
                        Name: row.name,
                    }

                    columns.forEach((column) => {
                        const header = column.Header || column.header || column.accessor
                        let cellValue = ''

                        if (
                            column.accessor !== 'applicant_screening' &&
                            column.accessor !== 'first_interview'
                        ) {
                            const rowValue = row[column.accessor] || 0
                            let resultValue = 0
                            if (row.name === 'From initial int') {
                                const firstInterviewValue = row.first_interview || 0
                                resultValue = firstInterviewValue
                                    ? (rowValue / firstInterviewValue) * 100
                                    : 0
                            }
                            if (row.name === 'From prev step') {
                                const prevStageValue =
                                    row[stageBindings[column.accessor]] || 0
                                resultValue = prevStageValue
                                    ? (rowValue / prevStageValue) * 100
                                    : 0
                            }
                            cellValue = `${resultValue.toFixed(2)}%`
                        }

                        formattedRow[header] = cellValue
                    })

                    return formattedRow
                })

                return response
            },
        },
    ]

    useEffect(() => {
        if (hasDownloadedRef.current) {
            return () => {
                dispatch(setDownload(''))
            }
        }
        hasDownloadedRef.current = true
        const toSheetName = (name, used) => {
            const trimmed = name.replace(/[\[\]\*\/\\\?\:]/g, '').slice(0, 31) // eslint-disable-line
            let uniqueName = trimmed || 'Sheet'
            let counter = 1
            while (used.has(uniqueName)) {
                const suffix = ` ${counter}`
                uniqueName = `${trimmed.slice(0, 31 - suffix.length)}${suffix}`
                counter += 1
            }
            used.add(uniqueName)
            return uniqueName
        }

        const loadData = async () => {
            const usedNames = new Set()
            const results = await Promise.all(
                csvData.map(async (item) => {
                    try {
                        const response = await item.fetchData()
                        return {
                            name: item.name,
                            data: response,
                        }
                    } catch (error) {
                        console.error(`TablesExport error: ${item.name}`, error)
                        return null
                    }
                })
            )

            const workbook = XLSX.utils.book_new()
            const filtersSheet = XLSX.utils.aoa_to_sheet([
                ['Filter', 'Value'],
                [
                    'Start Date',
                    filters?.dates?.[0]
                        ? new Date(filters.dates[0]).toLocaleDateString()
                        : '',
                ],
                [
                    'End Date',
                    filters?.dates?.[1]
                        ? new Date(filters.dates[1]).toLocaleDateString()
                        : '',
                ],
                ['Client', filters?.company_id || 'All Companies'],
                ['Vacancy', filters?.job_id || 'All Jobs'],
                ['Recruiter', filters?.recruiter_id || ''],
                ['Stage', tableFilters?.stage || 'All'],
                ['Channel', tableFilters?.channel || 'All'],
            ])
            XLSX.utils.book_append_sheet(workbook, filtersSheet, 'Filters')
            results.filter(Boolean).forEach((result) => {
                const sheetName = toSheetName(result.name, usedNames)
                const data = result.data || []
                const headers = data.length ? Object.keys(data[0]) : []
                const worksheet = XLSX.utils.json_to_sheet(data, {
                    header: headers,
                    skipHeader: false,
                })
                if (headers.length) {
                    const range = XLSX.utils.decode_range(worksheet['!ref'])
                    headers.forEach((_, index) => {
                        const cellAddress = XLSX.utils.encode_cell({ r: 0, c: index })
                        if (worksheet[cellAddress]) {
                            worksheet[cellAddress].s = {
                                font: { bold: true },
                            }
                        }
                    })
                    worksheet['!autofilter'] = { ref: XLSX.utils.encode_range(range) }
                    worksheet['!freeze'] = {
                        xSplit: 0,
                        ySplit: 1,
                        topLeftCell: 'A2',
                        activePane: 'bottomLeft',
                        state: 'frozen',
                    }
                    worksheet['!cols'] = headers.map((header) => {
                        const maxCellLength = Math.max(
                            header.length,
                            ...data.map((row) => String(row[header] ?? '').length)
                        )
                        return { wch: Math.min(Math.max(maxCellLength + 2, 10), 40) }
                    })
                }
                XLSX.utils.book_append_sheet(workbook, worksheet, sheetName)
            })

            if (workbook.SheetNames.length) {
                XLSX.writeFile(workbook, 'Dashboard_Tables.xlsx')
            }
        }

        loadData()

        return () => {
            dispatch(setDownload(''))
            dispatch(setLoading(false))
        }
    }, [])
}

export default TablesExport
